import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class EventsListPlayerService {
    apiUrl = environment.apiUrl;

    selectedEvent = null;
    // Set Local Storage Variable
    localStorage = window.localStorage;

    constructor(private http: HttpClient) {}

    // List of Players Events by User Id and Bucket ID
    getPlayerEventsList(playerID, bucketID): Observable<any> 
    {

        let url = `${ this.apiUrl }/api/v1/player-events-list/playerID/${ playerID }/bucketID/${ bucketID }`;

        return this.http.get(url);
    }

    // Get A Single Event Details
    // URL API did not return the Same event Details as what was in getEventPlayerList
    /*
    getEventDetails(eventID): Observable<any> 
    {

        let url = `${ this.apiUrl }/api/v1/events/${ eventID }`;

        return this.http.get(url);
    }   
    */

    // ----------------------------------------------------------------------------
    // Get A Single Event Details
    // Gets the Same Event Details as in the getEventPlayerList (Same Object Data)
    // ----------------------------------------------------------------------------
    getEventDetails(eventID, playerID)
    {
        let url = `${ this.apiUrl }/api/v1/player-events-list/playerID/${ playerID }/eventID/${ eventID }`;

        return this.http.get(url);
    }      


    // ----------------------------------------------------------------------------
    // Get A Single Event Details - SWAP
    // Gets the Same Event Details as in the getEventPlayerList (Same Object Data)
    // ----------------------------------------------------------------------------
    getEventSwapDetails(eventID, playerID)
    {
        let url = `${ this.apiUrl }/api/v1/player-events-swap-list/playerID/${ playerID }/eventID/${ eventID }`;

        return this.http.get(url);
    }   


    // ---------------------------------------------
    // Get Event Details from DB
    // ---------------------------------------------
    getEventsDetails(eventID)
    {
        let url = `${ this.apiUrl }/api/v1/events/${ eventID }`;
        
        return this.http.get(url);
    }    


    // Get Passcode Event Details
    getPasscodeEvent(passcode)
    {
        let url = `${ this.apiUrl }/api/v1/event-passcode/123455678`;
        // console.log('About to Event Details Data');

        return this.http.get(url);        
    }


    // Set the Selected Event Object Details in LOCAL Storage
    setSelectedEvent(eventObj)
    {   
        // console.log('Set Selected Object : ', eventObj);
        // set in any of your ts file
        localStorage.setItem('selectedEventObj', JSON.stringify(eventObj));
    }


    // Get Selected Event Object from Local Storage
    getSelectedEvent()
    {
        return JSON.parse(this.localStorage.getItem('selectedEventObj'));
    }



    // Set the autoLoginFlag in LOCAL Storage
    setAutoLoginFlag()
    {
        // console.log('Setting Aut Login Flag');
        // set in any of your ts file
        localStorage.setItem('autoLoginFlag', 'true');
    }

    // Get the autoLoginFlag in LOCAL Storage
    getAutoLoginFlag()
    {
        return this.localStorage.getItem('autoLoginFlag');
    }

    // Remove the autoLoginFlag in LOCAL Storage
    removeAutoLoginFlag()
    {
        // set in any of your ts file
        localStorage.removeItem('autoLoginFlag');
    }    


    // --------------------------------------------------
    // Set the autoLoginAdminDeviceObj in LOCAL Storage
    // --------------------------------------------------
    setAutoLoginAdminDeviceObj(data)
    {
        let autoLoginAdminDeviceObj = {
            autoLogin: true,
            leagueID: data.fldLeagueID,
            matchID: data.fldMatchID
        };
        console.log('Setting Aut Login Flag');
        // set in any of your ts file
        localStorage.setItem('autoLoginAdminDeviceObj', JSON.stringify(autoLoginAdminDeviceObj));
    }

    // --------------------------------------------------
    // Get the autoLoginAdminDeviceObj in LOCAL Storage
    // --------------------------------------------------
    getAutoLoginAdminDeviceObj()
    {
        return JSON.parse(this.localStorage.getItem('autoLoginAdminDeviceObj'));
    }

    // --------------------------------------------------
    // Remove the autoLoginAdminDeviceObj in LOCAL Storage
    // --------------------------------------------------
    removeAutoLoginAdminDeviceObj()
    {
        // set in any of your ts file
        localStorage.removeItem('autoLoginAdminDeviceObj');
    }     

}
